import type { v2 } from '@deque/billing-service-client';
import qs from 'qs';
import billingClient from '~/common/utils/billing-client/client-v2';
import { apiRequest } from '../../../api-client';

interface TeamsEndpointParams {
  token: string;
  enterpriseId: string;
}

interface TeamParams {
  id: string;
  name: string;
}

type GetMembershipParams = TeamsEndpointParams & Omit<TeamParams, 'name'>;

type CreateMembershipParams = GetMembershipParams & {
  keycloakIds: string[];
};

type DeleteMembershipsParams = CreateMembershipParams;

type GetInvitedMembersForTeamParams = {
  token: string;
  teamId: string;
  enterpriseId: string;
};

type InvitedTeamMember = Pick<v2.Invitation, 'email' | 'id' | 'team_ids'>;

export default {
  create: ({
    token,
    enterpriseId,
    id,
    keycloakIds
  }: CreateMembershipParams): Promise<void> => {
    const url_params = { keycloak_ids: keycloakIds };
    return apiRequest({
      endpoint: `/api/billing/v2/enterprises/${enterpriseId}/teams/${id}/memberships?${qs.stringify(
        url_params
      )}`,
      method: 'POST',
      token
    });
  },

  get: ({
    token,
    enterpriseId,
    id
  }: GetMembershipParams): Promise<v2.TeamMembership[]> => {
    return apiRequest({
      endpoint: `/api/billing/v2/enterprises/${enterpriseId}/teams/${id}/memberships`,
      method: 'GET',
      token
    });
  },

  getInvited: async ({
    token,
    teamId,
    enterpriseId
  }: GetInvitedMembersForTeamParams): Promise<InvitedTeamMember[]> => {
    const invitations = await billingClient.enterpriseInvitations.list({
      token,
      enterpriseId,
      isAccepted: false
    });

    const teamMembersInvitations =
      invitations.filter(({ team_ids }) => team_ids?.includes(teamId)) || [];

    return teamMembersInvitations.map(invitation => ({
      email: invitation.email,
      id: invitation.id,
      team_ids: invitation.team_ids
    }));
  },

  delete: ({
    token,
    enterpriseId,
    id,
    keycloakIds
  }: DeleteMembershipsParams): Promise<void> => {
    const url_params = { keycloak_ids: keycloakIds };
    return apiRequest({
      endpoint: `/api/billing/v2/enterprises/${enterpriseId}/teams/${id}/memberships?${qs.stringify(
        url_params
      )}`,
      method: 'DELETE',
      token
    });
  }
};
